const ProductsColorsStyle = () => `
<style>
  .red{
    background: #E9CBCC !important;
  }
  .magenta {
    background: #E9CBCC !important;
  }
  .purple {
    background: #CDC8DF !important;
  }
  .function-green {
    background: #8CE2D0 !important;
  }
  .orange {
    background: #F0CDA5 !important;
  }
  .dye-free {
    background: #ffffff !important;
  }
  .dye-free-hair-mask {
    background: #ede9e6 !important;
  }
  .rose-gold {
    background: #ffebdf !important;
  }
  .ocean {
    background: #dfeaf1 !important;
  }
  .sunkissed {
    background: #fffae7 !important;
  }
  .function-green {
    background: #8ce2d0 !important;
  }
  .flamingo {
    background: #ff9b85 !important;
  }
  .sunkissed {
    background: #ffeda7 !important
  }
  .coral {
    background: #f27e7e !important;
  }
  .dark-purple {
    background: #7161ac !important;
  }
  .blue {
    background: #c6dae7!important
  }
  .default {
    background: #f1f9f7 !important;
  }
</style>`;

export default ProductsColorsStyle;
